/** Platform-operator device fulfilment: physical inventory, serials, labels, orders. */
export const fulfilment = {
  inventory: {
    title: "Device inventory",
    description:
      "Physical player units you own: mint serial numbers, track status, and print labels.",
    addStock: "Add stock",
    empty: "No units yet. Add stock to mint your first serial numbers.",
    count: "{count} units",
    table: {
      select: "Select",
      serial: "Serial",
      status: "Status",
      model: "Model",
      batch: "Batch",
      created: "Added",
    },
    status: {
      in_stock: "In stock",
      allocated: "Allocated",
      shipped: "Shipped",
      provisioned: "Provisioned",
      retired: "Retired",
    },
    mint: {
      title: "Add stock",
      description:
        "Mint a block of new units in the {year} serial series. Each gets its own unique serial number.",
      count: "How many units",
      model: "Hardware model (optional)",
      modelPlaceholder: "e.g. OmniMedia Player v1",
      batch: "Batch (optional)",
      batchPlaceholder: "e.g. 2026-07",
      version: "Version",
      versionPlaceholder: "e.g. 1",
      submit: "Mint units",
    },
    toast: {
      minted: "Minted {count} units",
      mintFailed: "Could not mint units",
      updated: "Unit updated",
      updateFailed: "Could not update unit",
      nothingSelected: "Select at least one unit first",
      labelsReady: "Print bundle downloaded",
      labelsBuilding: "Building print bundle…",
      labelsFailed: "Could not build the print bundle",
    },
  },
  orders: {
    title: "Fulfilment orders",
    description:
      "Purchases awaiting shipment. Allocate units, print their labels, and mark them shipped.",
    empty: "No orders yet. They appear here when a customer checks out.",
    count: "{count} orders",
    quantity: "{count} licenses",
    noShipping: "No shipping address captured",
    allocated: "{count} of {total} units allocated",
    allocate: "Allocate {count}",
    allocateNone: "Fully allocated",
    printLabels: "Download labels",
    status: {
      needs_fulfillment: "Needs fulfilment",
      partially_shipped: "Partially shipped",
      shipped: "Shipped",
      cancelled: "Cancelled",
    },
    toast: {
      allocated: "Units allocated",
      allocateFailed: "Could not allocate. Is there stock?",
      updated: "Order updated",
      updateFailed: "Could not update order",
      noUnits: "Allocate units to this order first",
      labelsReady: "Print bundle downloaded",
      labelsBuilding: "Building print bundle…",
      labelsFailed: "Could not build the print bundle",
    },
  },
  labels: {
    heading: "Print labels",
    selectHint: "Select units above, then download their labels.",
    download: "Download labels",
    printShopNote:
      "Downloads one ZIP with everything a print shop needs: layered SVGs with a magenta CutContour for plotter shops, exact-size PDFs with 3mm bleed for per-piece sticker vendors, and an A4 sheet per unit. Type is converted to outlines, so the shop does not need the font, and nothing is rasterised. README.txt says which folder to send and which sizes to configure; PRINT-SPEC.txt is the technical sheet to hand over. Box-side and device-bottom labels carry a unique serial and QR per unit. Never let a shop duplicate one of those files. Measure a real device and scan a printed proof before committing to a run."
  },
} as const;
